import firebase from 'firebase/app'
import 'firebase/auth'
export default {
  computed: {
    firebaseUser () {
      return firebase.auth().currentUser
    }
  },
  methods: {
    logoutFromApp (destination = 'home') {
      firebase.auth().signOut()
        .then(() => {
          this.$store.dispatch('userLogout')
          this.navigateTo(destination)
        })
    }
  }
}
